export { default } from './parsePlaceholders';